var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "FormTitle" } }, [
    _c(
      "div",
      {
        class:
          "title-size-" +
          _vm.localTitleSize +
          " title-align-" +
          _vm.localTitleAlign +
          " form-title",
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localTitleText,
              expression: "localTitleText",
            },
          ],
          attrs: { type: "text", placeholder: "Başlık" },
          domProps: { value: _vm.localTitleText },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.localTitleText = $event.target.value
              },
              _vm.updateField,
            ],
          },
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localSubTitle,
              expression: "localSubTitle",
            },
          ],
          attrs: { type: "text", placeholder: "Bir alt başlık yazın" },
          domProps: { value: _vm.localSubTitle },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.localSubTitle = $event.target.value
              },
              _vm.updateField,
            ],
          },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }